import { css as s } from "lit";
const n = s`
  :host {
    box-sizing: border-box;
    font-family: var(--r5-font-sans);
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]) {
    display: none !important;
  }
`, r = s`
  .focus-ring:focus-visible {
    outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
    outline-offset: var(--r5-focus-ring-offset);
  }

  .focus-ring:focus:not(:focus-visible) {
    outline: none;
  }
`, e = s`
  :host([disabled]) {
    pointer-events: none;
    opacity: 0.5;
  }
`, a = s`
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;
function c(...o) {
  return o.flat();
}
function f(o, t) {
  return t ? `var(${o}, ${t})` : `var(${o})`;
}
export {
  f as a,
  n as b,
  c,
  e as d,
  r as f,
  a as s
};
//# sourceMappingURL=styles-scZ6dVz-.js.map
